// extracted by mini-css-extract-plugin
export default {"container":"SR-z","topReviewHeading":"TR-z","criticalReview":"UR-z","favorableReview":"VR-z","vsSeparator":"WR-z"};